import "./style.sass";
import assets from "../../assets";

export const MockTestHero = () => {
  return (
    <section className="mock-test-hero-container">
      <section className="icon-circle-mock">
        <img src={assets.ic_quest} alt="mock test" />
      </section>

      <h1 className="title">Practice Mode</h1>
      <p className="subtitle">
        Master your skills with previous year questions and real-time performance tracking
      </p>

      <section className="info-card">
        <h3>Why practice with Mock Tests?</h3>

        <div className="features-grid">
          <section className="feature">
            <section className="feature-icon">📚</section>
            <section>
              <h4>Year-wise Practice</h4>
              <p>
                Access a comprehensive database of previous year questions.
              </p>
            </section>
          </section>

          <section className="feature">
            <section className="feature-icon">🚀</section>
            <section>
              <h4>Exam Readiness</h4>
              <p>
                Simulate real exam conditions to build your confidence.
              </p>
            </section>
          </section>

          <section className="feature">
            <section className="feature-icon">📊</section>
            <section>
              <h4>Detailed Analysis</h4>
              <p>
                Track your progress with in-depth score breakdowns.
              </p>
            </section>
          </section>
        </div>
      </section>

      <section className="instruction-box">
        Get started by selecting your year from the dropdown menu in the left panel
      </section>
    </section>
  );
};
